import React, { useState, useRef } from "react";
import "../styles/TelemetryUploadPage.css";
import telemScreenshot from "../assets/telem-screenshot.png";

const API_BASE = "https://iracing6-backend.herokuapp.com/api";

export const TelemetryUploadPage = () => {
        const [isDragging, setIsDragging] = useState(false);
        const [isUploading, setIsUploading] = useState(false);
        const [uploadResults, setUploadResults] = useState([]);
        const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0 });
        const [privateTelemetry, setPrivateTelemetry] = useState(false);
        const fileInputRef = useRef(null);

        const isLoggedIn = !!localStorage.getItem("token");

        const handleDragOver = (e) => {
                e.preventDefault();
                setIsDragging(true);
        };

        const handleDragLeave = (e) => {
                e.preventDefault();
                setIsDragging(false);
        };

        const handleDrop = (e) => {
                e.preventDefault();
                setIsDragging(false);

                const files = Array.from(e.dataTransfer.files);
                const ibtFiles = files.filter((file) => file.name.toLowerCase().endsWith(".ibt"));

                if (ibtFiles.length > 0) {
                        handleUploadMultiple(ibtFiles);
                } else {
                        setUploadResults([{ fileName: "Unknown", success: false, error: "Please drop valid .ibt files" }]);
                }
        };

        const handleFileSelect = (e) => {
                const files = Array.from(e.target.files);
                if (files.length > 0) {
                        handleUploadMultiple(files);
                }
        };

        const uploadSingleFile = async (file) => {
                if (!file.name.toLowerCase().endsWith(".ibt")) {
                        return { fileName: file.name, success: false, error: "Invalid file format" };
                }

                const token = localStorage.getItem("token");
                const formData = new FormData();
                formData.append("file", file);
                formData.append("privateTelemetry", (isLoggedIn && privateTelemetry).toString());

                try {
                        const headers = {};
                        if (token) {
                                headers.Authorization = `Bearer ${token}`;
                        }

                        const response = await fetch(`${API_BASE}/telemetry/upload-web`, {
                                method: "POST",
                                headers,
                                body: formData,
                        });

                        const data = await response.json();

                        if (response.ok) {
                                return { fileName: file.name, success: true, data };
                        } else if (response.status === 401) {
                                return { fileName: file.name, success: false, error: "Session expired" };
                        } else if (response.status === 409) {
                                return { fileName: file.name, success: false, error: "Already uploaded" };
                        } else if (response.status === 422) {
                                return { fileName: file.name, success: false, error: "Invalid file" };
                        } else {
                                return { fileName: file.name, success: false, error: data.message || "Upload failed" };
                        }
                } catch (err) {
                        return { fileName: file.name, success: false, error: "Network error" };
                }
        };

        const handleUploadMultiple = async (files) => {
                setIsUploading(true);
                setUploadResults([]);
                setUploadProgress({ current: 0, total: files.length });

                const results = [];
                for (let i = 0; i < files.length; i++) {
                        setUploadProgress({ current: i + 1, total: files.length });
                        const result = await uploadSingleFile(files[i]);
                        results.push(result);
                        setUploadResults([...results]);
                }

                setIsUploading(false);
                if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                }
        };

        const handleDownload = () => {
                const link = document.createElement("a");
                link.href = "/downloads/iRacingDataTelemetryUploader-Setup.exe";
                link.download = "iRacingDataTelemetryUploader-Setup.exe";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
        };

        const successCount = uploadResults.filter((r) => r.success).length;
        const failCount = uploadResults.filter((r) => !r.success).length;

        return (
                <div className="telemetry-upload-page">
                        <div className="upload-card">
                                <h1>Upload Telemetry</h1>

                                {/* Web Upload Section */}
                                <div className="section-card upload-section">
                                        <h3>Web Upload</h3>
                                        <div
                                                className={`drop-zone ${isDragging ? "dragging" : ""} ${isUploading ? "uploading" : ""}`}
                                                onDragOver={handleDragOver}
                                                onDragLeave={handleDragLeave}
                                                onDrop={handleDrop}
                                                onClick={() => !isUploading && fileInputRef.current?.click()}
                                        >
                                                <input type="file" ref={fileInputRef} accept=".ibt" multiple onChange={handleFileSelect} style={{ display: "none" }} />
                                                {isUploading ? (
                                                        <div className="upload-spinner">
                                                                <div className="upload-spinner-icon"></div>
                                                                <p>
                                                                        Uploading {uploadProgress.current} of {uploadProgress.total}...
                                                                </p>
                                                        </div>
                                                ) : (
                                                        <>
                                                                <div className="drop-icon">
                                                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                                                <polyline points="17 8 12 3 7 8" />
                                                                                <line x1="12" y1="3" x2="12" y2="15" />
                                                                        </svg>
                                                                </div>
                                                                <p className="drop-text">Drag & drop your .ibt files here</p>
                                                                <p className="drop-subtext">or click to browse (multiple files supported)</p>
                                                                <p className="drop-path-hint">
                                                                        Telemetry files are typically found in:
                                                                        <br />
                                                                        C:\Users\[YourName]\Documents\iRacing\telemetry
                                                                </p>
                                                        </>
                                                )}
                                        </div>

                                        {isLoggedIn ? (
                                                <label className="private-checkbox">
                                                        <input type="checkbox" checked={privateTelemetry} onChange={(e) => setPrivateTelemetry(e.target.checked)} />
                                                        <span>Private telemetry</span>
                                                        <span className="checkbox-hint">(Hidden from search, world records, and contests)</span>
                                                </label>
                                        ) : (
                                                <p className="login-hint">
                                                        <a href="/login">Log in</a> to upload private telemetry
                                                </p>
                                        )}

                                        {uploadResults.length > 0 && (
                                                <div className="upload-results">
                                                        {uploadResults.length > 1 && (
                                                                <div className="upload-summary">
                                                                        <span className="summary-success">{successCount} succeeded</span>
                                                                        {failCount > 0 && <span className="summary-fail">{failCount} failed</span>}
                                                                </div>
                                                        )}
                                                        <div className="upload-results-list">
                                                                {uploadResults.map((result, index) => (
                                                                        <div key={index} className={`upload-result-item ${result.success ? "success" : "error"}`}>
                                                                                <span className="result-icon">{result.success ? "✓" : "✗"}</span>
                                                                                <span className="result-filename">{result.fileName}</span>
                                                                                {result.success ? (
                                                                                        <span className="result-details">
                                                                                                {result.data.track} • {result.data.car} • {result.data.lapsProcessed} laps
                                                                                        </span>
                                                                                ) : (
                                                                                        <span className="result-error">{result.error}</span>
                                                                                )}
                                                                        </div>
                                                                ))}
                                                        </div>
                                                </div>
                                        )}
                                </div>

                                {/* Desktop Tool Download Section */}
                                <div className="section-card download-section">
                                        <h3>Desktop Uploader Tool</h3>
                                        <p className="section-description">Prefer a desktop app? Download our tool for bulk uploads.</p>

                                        <button className="download-button" onClick={handleDownload}>
                                                Download
                                        </button>
                                        <p className="file-info">iRacingDataTelemetryUploader-Setup.exe</p>

                                        <div className="subsection requirements">
                                                <h4>Requirements</h4>
                                                <ul>
                                                        <li>Windows 10 or later</li>
                                                        <li>iRacing installed</li>
                                                        <li>iRacing logging enabled (Alt + L while in sim)</li>
                                                </ul>
                                        </div>

                                        <div className="subsection instructions">
                                                <h4>Installation</h4>
                                                <ol>
                                                        <li>Download the installer above</li>
                                                        <li>Run the setup executable</li>
                                                        <li>Follow the installation prompts</li>
                                                </ol>
                                        </div>

                                        <div className="subsection usage">
                                                <h4>Usage</h4>
                                                <ol>
                                                        <li>Launch the app</li>
                                                        <li>Click "Upload Telemetry Files" to upload any telemetry files saved by the sim</li>
                                                </ol>
                                                <img src={telemScreenshot} alt="Telemetry Uploader Screenshot" className="telem-screenshot" />
                                        </div>
                                </div>
                        </div>
                </div>
        );
};

export default TelemetryUploadPage;
